import React, { useRef, useState } from 'react'
import './Product.css'
import Cookies from 'js-cookie'
import userApi from '../../Common/Api/UserApi'
import { useSelector } from 'react-redux'


export default function Product(props) {
    
    const checkbox = useRef();
    const checkbox2 = useRef();
    

    const {BookWormUser} = useSelector((state)=>state)
    const [removed,setRemoved] = useState(false);
    const [removeModal,setRemoveModal] = useState(false);


    const [sold,setSold] = useState(props.sold);

    const deleteFromCart = async(id)=>{

        if(checkbox.current.checked )
            props.setTotal(props.total-props.price)
        if(checkbox2.current.checked)
            props.setTotal(props.total-props.price)

        

        const res = await userApi.post('/user/delete-from-cart',{
            user :{
                _id:BookWormUser.userInfo._id
            },
            adId:props.id
        },{
            headers:{
              'Authorization': `Bearer ${Cookies.get('token')}`
            }
        })
        console.log(res);

        setRemoved(true);
        setRemoveModal(false);


    }

    const checkboxClick = ()=>{
        checkbox.current.checked?props.setTotal(props.total+props.price):props.setTotal(props.total-props.price);

        checkbox.current.checked?props.setToBuy([...props.toBuy,{id:props.id, price:props.price,title:props.name ,img:props.img,sellerId:props.sellerId }]):props.setToBuy(props.toBuy.filter((element)=>{ return element.id!=props.id }))
    }
    const checkboxClick2 = ()=>{
        checkbox2.current.checked?props.setTotal(props.total+props.price):props.setTotal(props.total-props.price);

        checkbox2.current.checked?props.setToBuy([...props.toBuy,{id:props.id, price:props.price,title:props.name ,img:props.img,sellerId:props.sellerId }]):props.setToBuy(props.toBuy.filter((element)=>{ return element.id!=props.id }))
    }

  return (
    <div className={removed?'removed':''}>
      <div className='Product' >
        <div className="ProductImage" style={sold?{filter:'brightness(70%)'}:{}}>
            <input  className='checkbox' type="checkbox"  id={props.id} name={props.name} value="true" ref={checkbox} onClick={checkboxClick} disabled={sold}/>
            <img src={props.img} className='prodImg' alt="Product" />
            <input  className='checkbox2' type="checkbox"  id={props.id} name={props.name} value="true" ref={checkbox2} onClick={checkboxClick2} disabled={sold}/>
        </div>
        <div className="ProductDetails">
            <h4>{props.name}</h4>
            <p>By: {props.author}</p>
        </div>
        <div className="ProductPrice">
            <h4>Rs. {props.price}</h4>
            <i className="fa-solid fa-trash-can" onClick={()=>setRemoveModal(true)}></i>
        </div>

        <div className='product-del'>
        </div>

        {sold  && <div className='product-alert'>
            <i class="fa-solid fa-triangle-exclamation"></i>
            Oops, This Product is already Sold !
        </div>}
      </div>
        <hr />

        {removeModal && <div className='Modal'>
                <div className='modal-container'>
                    <i className="fa-solid fa-xmark edit-close" onClick={()=>setRemoveModal(false)}></i>
                    <h4>Are you sure you want to remove this book from Cart?</h4>
                    
                    <button onClick={()=>deleteFromCart(props.id)}>Confirm</button>
                </div>
        </div>}
    </div>
   
  )
}
